module.exports = __webpack_public_path__ + "img/1.66ca8994.png";